module.exports = __webpack_public_path__ + "img/aa3f52c.jpg";